import { render, staticRenderFns } from "./PcProductItem.vue?vue&type=template&id=74c20a42&scoped=true&"
import script from "./PcProductItem.vue?vue&type=script&lang=js&"
export * from "./PcProductItem.vue?vue&type=script&lang=js&"
import style0 from "./PcProductItem.vue?vue&type=style&index=0&id=74c20a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c20a42",
  null
  
)

export default component.exports